import { testimonialsData } from "@/mocks/landingData";

export default function Testimonials() {
  return (
    <section className="section-padding relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-teal-500/5 to-transparent pointer-events-none" />

      <div className="container-main relative">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="v2-section-label justify-center">
            <span className="w-8 h-px bg-teal-400" />
            آراء العملاء
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mt-4">
            <span className="title-line-1">ما يقوله عملاؤنا</span>
            <span className="title-line-2 v2-gradient-text">عنا</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonialsData.map((testimonial, index) => (
            <blockquote
              key={index}
              className="v2-glass-card-hover p-8 relative"
            >
              <div className="absolute top-6 left-6 text-6xl text-teal-500/10 font-serif leading-none">
                &ldquo;
              </div>
              <div className="flex items-center gap-1 mb-5 relative">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <p className="text-slate-300 leading-relaxed mb-8 text-sm md:text-base relative">
                {testimonial.content}
              </p>
              <footer className="flex items-center gap-4 pt-5 border-t border-white/10">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <cite className="font-bold text-white text-sm not-italic">
                    {testimonial.name}
                  </cite>
                  <div className="text-xs text-slate-500">
                    {testimonial.role}
                  </div>
                </div>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
